/**
 * @file battery.ts
 * @description Telink 3228C 维盛 AP 鼠标 AD 电量查询与 BD 续航读取。
 */

import {
  BatteryFeature,
  type BatteryRuntime,
  type BatteryStatus,
} from '../../../../features/battery/contract'
import type { BaseDevice } from '../../../../runtime/BaseDevice'

interface TelinkApMouseBatteryDevice extends BaseDevice {
  readBatteryStatus(): Promise<BatteryStatus>
  readBatteryRuntime(): Promise<BatteryRuntime>
}

/**
 * VT2 ULTRA V2 的电量、充电状态与续航时间查询。
 *
 * AD 请求帧 LEN=6、ADDR=0 已由官方驱动抓包确认（含充电与未充电两种回包样本）；
 * BD 续航按 V0106 §2.2.18 读取 4 字节大端小时数。Web 显式调用与设备连接阶段的
 * 首页电量快照预热共用 AD 查询；续航只在性能页显式读取，不参与电量百分比或休眠策略。
 */
export class Telink3228CMouseBattery extends BatteryFeature {
  private readonly apDevice: TelinkApMouseBatteryDevice

  constructor(device: TelinkApMouseBatteryDevice) {
    super(device)
    this.apDevice = device
  }

  public async getBatteryStatus(): Promise<BatteryStatus> {
    return this.apDevice.readBatteryStatus()
  }

  public async getBatteryRuntime(): Promise<BatteryRuntime> {
    return this.apDevice.readBatteryRuntime()
  }
}
